import { Link } from "@at/design-system-elements";
import { BREAKPOINTS } from "@at/window-utils";
import styled from "styled-components";

export const StyledGalleryImage = styled(Link)<{ isClickable?: boolean }>`
  display: block;
  width: 100%;
  border: none;
  position: relative;
  padding: 0;
  overflow: hidden;
  -webkit-tap-highlight-color: transparent;
  background: none;

  ${({ isClickable }) =>
    isClickable &&
    `
    @media screen and (min-width: ${BREAKPOINTS.MEDIUM}px) {
    &:after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.2);
      opacity: 0;
      transition: opacity 0.6s ease-in-out;
    }

    &:hover:after {
      opacity: 1;
}}`}

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px #29dcff;
  }

  img {
    display: block;
  }

  @media print {
    display: block;
    position: static;
    &:after {
      display: none;
    }

    img {
      width: 100%;
      height: auto;
      display: block;
    }

    &:focus {
      box-shadow: none;
    }
  }
`;
